import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/falken-page-logo.png'
import _imports_1 from '@/assets/tcp-page-logo.png'
import _imports_2 from '@/assets/Eligibility-falken.png'
import _imports_3 from '@/assets/Eligibility.png'
import _imports_4 from '@/assets/Warranty-falken.png'
import _imports_5 from '@/assets/Warranty.png'
import _imports_6 from '@/assets/Coverage-falken.png'
import _imports_7 from '@/assets/Coverage.png'


const _hoisted_1 = { class: "p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "max-w-7xl mx-auto mb-4 sm:mb-6" }
const _hoisted_3 = { class: "overflow-hidden" }
const _hoisted_4 = { class: "p-6 sm:p-8 lg:p-10" }
const _hoisted_5 = { class: "flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 mb-6" }
const _hoisted_6 = {
  class: "flex-shrink-0 sm:w-20 sm:h-20 md:w-[210px] rounded-2xl flex items-center justify-center",
  style: { backgroundColor: 'var(--brand-primary)' + '20' }
}
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  alt: "Logo",
  class: "w-full sm:w-[150px] max-w-[300px] md:w-[200px] lg:w-[300px] p-2 md:mr-9"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  alt: "Logo",
  class: "w-full p-2"
}
const _hoisted_9 = { class: "flex-1" }
const _hoisted_10 = { class: "text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-3" }
const _hoisted_11 = {
  key: 0,
  class: "text-base sm:text-lg text-gray-700 dark:text-gray-300 leading-relaxed"
}
const _hoisted_12 = {
  key: 1,
  class: "text-base sm:text-lg text-gray-700 dark:text-gray-300 leading-relaxed"
}
const _hoisted_13 = { class: "max-w-7xl mx-auto mb-4 sm:mb-6" }
const _hoisted_14 = { class: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6" }
const _hoisted_15 = { class: "bg-gray-50 dark:bg-black rounded-xl shadow-md overflow-hidden border border-gray-200 dark:border-gray-700 transition-all duration-300 hover:shadow-xl hover:-translate-y-1" }
const _hoisted_16 = { class: "p-6" }
const _hoisted_17 = { class: "rounded-xl flex items-center justify-center mb-4" }
const _hoisted_18 = {
  key: 0,
  src: _imports_2,
  alt: "Logo",
  class: "w-16 p-2"
}
const _hoisted_19 = {
  key: 1,
  src: _imports_3,
  alt: "Logo",
  class: "w-16 p-2"
}
const _hoisted_20 = { class: "space-y-3" }
const _hoisted_21 = { class: "flex items-start" }
const _hoisted_22 = { class: "text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_23 = { class: "bg-gray-50 dark:bg-black rounded-xl shadow-md overflow-hidden border border-gray-200 dark:border-gray-700 transition-all duration-300 hover:shadow-xl hover:-translate-y-1" }
const _hoisted_24 = { class: "p-6" }
const _hoisted_25 = {
  class: "rounded-xl flex items-center justify-center mb-4",
  style: { backgroundColor: 'var(--brand-primary)' + '20' }
}
const _hoisted_26 = {
  key: 0,
  src: _imports_4,
  alt: "Logo",
  class: "w-16 p-2"
}
const _hoisted_27 = {
  key: 1,
  src: _imports_5,
  alt: "Logo",
  class: "w-16 p-2"
}
const _hoisted_28 = { class: "bg-gray-50 dark:bg-black rounded-xl shadow-md overflow-hidden border border-gray-200 dark:border-gray-700 transition-all duration-300 hover:shadow-xl hover:-translate-y-1" }
const _hoisted_29 = { class: "p-6" }
const _hoisted_30 = {
  class: "rounded-xl flex items-center justify-center mb-4",
  style: { backgroundColor: 'var(--brand-primary)' + '20' }
}
const _hoisted_31 = {
  key: 0,
  src: _imports_6,
  alt: "Logo",
  class: "w-16 p-2"
}
const _hoisted_32 = {
  key: 1,
  src: _imports_7,
  alt: "Logo",
  class: "w-16 p-2"
}
const _hoisted_33 = { class: "space-y-3" }
const _hoisted_34 = { class: "flex items-start" }
const _hoisted_35 = { class: "text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_36 = { class: "flex items-start" }
const _hoisted_37 = { class: "text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_38 = { class: "max-w-7xl mx-auto mb-4 sm:mb-6" }
const _hoisted_39 = { class: "max-w-6xl mx-auto px-6 py-16 text-center" }
const _hoisted_40 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 place-items-center" }
const _hoisted_41 = { class: "relative w-64 h-64 rounded-full bg-black text-white flex items-center justify-center text-center p-6 shadow-lg" }
const _hoisted_42 = { class: "relative" }
const _hoisted_43 = { class: "text-sm leading-relaxed" }
const _hoisted_44 = { class: "relative w-64 h-64 rounded-full bg-black text-white flex items-center justify-center text-center p-6 shadow-lg" }
const _hoisted_45 = { class: "relative" }
const _hoisted_46 = { class: "text-sm leading-relaxed" }
const _hoisted_47 = {
  key: 0,
  class: "mt-20"
}

import { computed } from 'vue'
import { useTitle } from '@/composables/ui/useTitle'
import { useBrand } from '@/composables/brand/useBrand'


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const { currentBrand } = useBrand()
const isFalken = computed(() => currentBrand.value?.name?.toLowerCase() === 'falken')

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'SP Team Template')

useTitle(`${appTitle.value} - ${isFalken.value ? 'What is RHR?' : 'What is TCP?'}`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (isFalken.value)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : (_openBlock(), _createElementBlock("img", _hoisted_8))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h2", _hoisted_10, _toDisplayString(isFalken.value ? 'What is Road Hazard Ready (RHR)?' : 'What is Total Confidence Plan (TCP)?'), 1),
              (isFalken.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Road Hazard Ready (RHR) provides eligible retail customers of selected Falken tires with enhanced warranty coverage for 12 months from the date of purchase againts qualified road-hazard damages. This includes a one-to-one tire replacement at no extra cost to the customer. "))
                : (_openBlock(), _createElementBlock("p", _hoisted_12, " Total Confidence Plan (TCP) provides eligible retail customers of Continental tires with enhanced warranty coverage for 12 months from the date of purchase against qualified road-hazard damages. This includes a one-to-one tire replacement at no extra cost to the customer. "))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              (isFalken.value)
                ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                : (_openBlock(), _createElementBlock("img", _hoisted_19)),
              _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "text-xl font-bold text-gray-900 dark:text-white" }, " ELIGIBILITY ", -1))
            ]),
            _createElementVNode("ul", _hoisted_20, [
              _createElementVNode("li", _hoisted_21, [
                _cache[1] || (_cache[1] = _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "20",
                  height: "20",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  class: "lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0"
                }, [
                  _createElementVNode("path", { d: "M21.801 10A10 10 0 1 1 17 3.335" }),
                  _createElementVNode("path", { d: "m9 11 3 3L22 4" })
                ], -1)),
                _createElementVNode("span", _hoisted_22, _toDisplayString(isFalken.value ? 'Selected Falken passenger and light truck (PLT) tires only. Azenis RT660, RT615K+ and Commercial tires are NOT included.' : 'Continental Passenger, SUV/4X4, and Van/Light Truck tires (PLT). Commercial tires are NOT included.'), 1)
              ]),
              _cache[2] || (_cache[2] = _createStaticVNode("<li class=\"flex items-start\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0\"><path d=\"M21.801 10A10 10 0 1 1 17 3.335\"></path><path d=\"m9 11 3 3L22 4\"></path></svg><span class=\"text-sm text-gray-700 dark:text-gray-300\"> Requires the purchase of at least two (2) PLT tires in one (1) single transaction. </span></li><li class=\"flex items-start\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0\"><path d=\"M21.801 10A10 10 0 1 1 17 3.335\"></path><path d=\"m9 11 3 3L22 4\"></path></svg><span class=\"text-sm text-gray-700 dark:text-gray-300\"> Customer must register their tires within seven (7) days from date of purchase. </span></li>", 2))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              (isFalken.value)
                ? (_openBlock(), _createElementBlock("img", _hoisted_26))
                : (_openBlock(), _createElementBlock("img", _hoisted_27)),
              _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-xl font-bold text-gray-900 dark:text-white" }, " WARRANTY ", -1))
            ]),
            _cache[4] || (_cache[4] = _createStaticVNode("<ul class=\"space-y-3\"><li class=\"flex items-start\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0\"><path d=\"M21.801 10A10 10 0 1 1 17 3.335\"></path><path d=\"m9 11 3 3L22 4\"></path></svg><span class=\"text-sm text-gray-700 dark:text-gray-300\"> First 12 months upon purchase (based on the date indicated on the official receipt). </span></li><li class=\"flex items-start\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0\"><path d=\"M21.801 10A10 10 0 1 1 17 3.335\"></path><path d=\"m9 11 3 3L22 4\"></path></svg><span class=\"text-sm text-gray-700 dark:text-gray-300\"> If unrepairable tire damage, 1-to-1 replacement (if RTD* ≥ 5mm) - applicable only to all unrepairable damage. </span></li><li class=\"flex items-start\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0\"><path d=\"M21.801 10A10 10 0 1 1 17 3.335\"></path><path d=\"m9 11 3 3L22 4\"></path></svg><span class=\"text-sm text-gray-700 dark:text-gray-300\"> All service charges during claim procedure (mounting / balancing /alignment) to be borne by consumer. </span></li><li class=\"flex items-start\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0 invisible\"><path d=\"M21.801 10A10 10 0 1 1 17 3.335\"></path><path d=\"m9 11 3 3L22 4\"></path></svg><span class=\"text-sm text-gray-700 dark:text-gray-300\"> *RTD = remaining tread depth </span></li></ul>", 1))
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              (isFalken.value)
                ? (_openBlock(), _createElementBlock("img", _hoisted_31))
                : (_openBlock(), _createElementBlock("img", _hoisted_32)),
              _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-xl font-bold text-gray-900 dark:text-white" }, " COVERAGE ", -1))
            ]),
            _createElementVNode("ul", _hoisted_33, [
              _cache[8] || (_cache[8] = _createStaticVNode("<li class=\"flex items-start\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0\"><path d=\"M21.801 10A10 10 0 1 1 17 3.335\"></path><path d=\"m9 11 3 3L22 4\"></path></svg><span class=\"text-sm text-gray-700 dark:text-gray-300\"> Tires must be purchased from any JMFEI authorized dealers or sub-dealers. </span></li>", 1)),
              _createElementVNode("li", _hoisted_34, [
                _cache[6] || (_cache[6] = _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "20",
                  height: "20",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  class: "lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0"
                }, [
                  _createElementVNode("path", { d: "M21.801 10A10 10 0 1 1 17 3.335" }),
                  _createElementVNode("path", { d: "m9 11 3 3L22 4" })
                ], -1)),
                _createElementVNode("span", _hoisted_35, _toDisplayString(isFalken.value ? 'Purchases from the official online stores of Falken Tire Philippines are also included.' : 'Purchases from the official online stores of Continental Tire Philippines are also included.'), 1)
              ]),
              _createElementVNode("li", _hoisted_36, [
                _cache[7] || (_cache[7] = _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "20",
                  height: "20",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  class: "lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0"
                }, [
                  _createElementVNode("path", { d: "M21.801 10A10 10 0 1 1 17 3.335" }),
                  _createElementVNode("path", { d: "m9 11 3 3L22 4" })
                ], -1)),
                _createElementVNode("span", _hoisted_37, _toDisplayString(isFalken.value ? 'PLT tires up to six (6) years old from current calendar year are eligible for this program.' : 'Only Continental Passenger, SUV/4X4, and Van/Light Truck (PLT) tires with a date of manufacture within nine (9) years from the current calendar year are eligible for this Program.'), 1)
              ]),
              _cache[9] || (_cache[9] = _createStaticVNode("<li class=\"flex items-start\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-circle-check-big-icon lucide-circle-check-big text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0\"><path d=\"M21.801 10A10 10 0 1 1 17 3.335\"></path><path d=\"m9 11 3 3L22 4\"></path></svg><span class=\"text-sm text-gray-700 dark:text-gray-300\"> OE fitted tires are not included. </span></li>", 1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("section", _hoisted_39, [
        _cache[16] || (_cache[16] = _createElementVNode("h2", {
          class: "text-3xl md:text-4xl font-bold mb-3",
          style: { color: 'var(--brand-primary)' }
        }, " Give your tires the protection they deserve ", -1)),
        _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-gray-700 dark:text-white text-lg mb-12" }, " 4 Easy Steps to Enjoy Added Confidence ", -1)),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _cache[11] || (_cache[11] = _createElementVNode("div", {
              class: "absolute inset-0 rounded-full border-4",
              style: { borderColor: 'var(--brand-primary)' }
            }, null, -1)),
            _createElementVNode("div", _hoisted_42, [
              _cache[10] || (_cache[10] = _createElementVNode("p", { class: "font-semibold tracking-wide mb-3" }, "STEP 01", -1)),
              _createElementVNode("p", _hoisted_43, " Buy a min. of two (2) pcs. of " + _toDisplayString(isFalken.value ? 'participating Falken' : 'Continental') + " PLT tires at any authorized dealer. ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _cache[13] || (_cache[13] = _createElementVNode("div", {
              class: "absolute inset-0 rounded-full border-4",
              style: { borderColor: 'var(--brand-primary)' }
            }, null, -1)),
            _createElementVNode("div", _hoisted_45, [
              _cache[12] || (_cache[12] = _createElementVNode("p", { class: "font-semibold tracking-wide mb-3" }, "STEP 02", -1)),
              _createElementVNode("p", _hoisted_46, " Create your " + _toDisplayString(isFalken.value ? 'Falken' : 'Continental') + " account and register your personal details. ", 1)
            ])
          ]),
          _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"relative w-64 h-64 rounded-full bg-black text-white flex items-center justify-center text-center p-6 shadow-lg\"><div class=\"absolute inset-0 rounded-full border-4\" style=\"border-color:var(--brand-primary);\"></div><div class=\"relative\"><p class=\"font-semibold tracking-wide mb-3\">STEP 03</p><p class=\"text-sm leading-relaxed\"> Register your vehicle and your tires within seven (7) days from purchase date. </p></div></div><div class=\"relative w-64 h-64 rounded-full bg-black text-white flex items-center justify-center text-center p-6 shadow-lg\"><div class=\"absolute inset-0 rounded-full border-4\" style=\"border-color:var(--brand-primary);\"></div><div class=\"relative\"><p class=\"font-semibold tracking-wide mb-3\">STEP 04</p><p class=\"text-sm leading-relaxed\"> Receive a confirmation of your tire registration. </p><p class=\"text-xs text-gray-300 mt-3\"> All registrations are subject for approval. </p></div></div>", 2))
        ]),
        (isFalken.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, _cache[15] || (_cache[15] = [
              _createStaticVNode("<h3 class=\"text-2xl font-semibold mb-12 text-center text-blue-600 dark:text-blue-400\">Participating Patterns</h3><div class=\"grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-8 text-sm text-center\"><div class=\"flex flex-col items-center\"><h4 class=\"font-black text-4xl italic tracking-wider mb-4 uppercase text-black dark:text-white\">Sincera</h4><ul class=\"space-y-1 text-blue-600 dark:text-blue-400 font-medium text-center text-base\"><li>Sincera SN832i</li></ul></div><div class=\"flex flex-col items-center\"><h4 class=\"font-black text-4xl italic tracking-wider mb-4 uppercase text-black dark:text-white\">Ziex</h4><ul class=\"space-y-1 text-blue-600 dark:text-blue-400 font-medium text-center text-base\"><li>Ziex ZE310</li><li>Ziex STZ05</li></ul></div><div class=\"flex flex-col items-center\"><h4 class=\"font-black text-4xl italic tracking-wider mb-4 uppercase text-black dark:text-white\">Azenis</h4><ul class=\"space-y-1 text-blue-600 dark:text-blue-400 font-medium mb-4 text-center text-base\"><li>Azenis FK510</li><li>Azenis FK510 SUV</li><li>Azenis FK520L</li></ul><div class=\"text-center\"><span class=\"text-red-500 font-bold uppercase block mb-1 underline\">NOT INCLUDED:</span><ul class=\"space-y-1 text-blue-600 dark:text-blue-400 font-medium text-base\"><li>Azenis RT660</li><li>Azenis RT615K+</li></ul></div></div><div class=\"flex flex-col items-center\"><h4 class=\"font-black text-4xl italic tracking-wider mb-4 uppercase text-black dark:text-white\">Wildpeak</h4><ul class=\"space-y-1 text-blue-600 dark:text-blue-400 font-medium text-center text-base\"><li>Wildpeak A/T Trail</li><li>Wildpeak HT01</li><li>Wildpeak AT3W</li><li>Wildpeak AT4W</li><li>Wildpeak RT01</li><li>Wildpeak MT01</li></ul></div><div class=\"flex flex-col items-center\"><h4 class=\"font-black text-4xl italic tracking-wider mb-4 uppercase text-black dark:text-white\">Linam</h4><ul class=\"space-y-1 text-blue-600 dark:text-blue-400 font-medium text-center text-base\"><li>Linam Van01</li></ul></div></div>", 2)
            ])))
          : _createCommentVNode("", true),
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "mt-14 text-gray-700 dark:text-white text-lg" }, [
          _createTextVNode(" Got questions? Click here: "),
          _createElementVNode("a", {
            href: "#",
            class: "font-semibold hover:underline",
            style: { color: 'var(--brand-primary)' }
          }, " Mechanics "),
          _createTextVNode(" and "),
          _createElementVNode("a", {
            href: "#",
            class: "font-semibold hover:underline",
            style: { color: 'var(--brand-primary)' }
          }, " Terms & Conditions ")
        ], -1))
      ])
    ])
  ]))
}
}

})